<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({mixins: [Breadcrumbs]})
    export class InsuranceBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest

        get items() {
            const name = useRoute().name
            const items = [this.homeItem]
            switch (name) {
                case 'insuranceSearch':
                    items.push({
                        title: `${insuranceRuntimeStore.location.name}`,
                        to: insuranceRuntimeStore.searchPageLink(this.searchRequest),
                        disabled: true,
                        exact: true,
                    })
                    break
                case 'insurance':
                    break
                case 'insuranceBooking':
                    items.push({
                        title: `${insuranceRuntimeStore.location.name}`,
                        to: insuranceRuntimeStore.searchPageLink(this.searchRequest),
                        exact: true,
                    })
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'insuranceConfirmation':
                    break
            }
            return items
        }
    }

    export default {...toNative(InsuranceBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
